declare const $: any;

const patchFlag = '__c360IframePrintPatched';

const printPageStyle = `
<style id="c360-datatables-print-page-style">
  @page {
    size: auto;
    margin: 0 0 7mm 0 !important;

    @bottom-right {
      content: counter(page) "/" counter(pages);
      color: #000;
      font-size: 8px;
      margin-right: 4mm;
    }
  }

  @media print {
    html,
    body.dt-print-view {
      margin: 0 !important;
      min-height: 100% !important;
      width: 100% !important;
    }

    body.dt-print-view {
      box-sizing: border-box !important;
      padding: 8mm 10mm 4mm !important;
      -webkit-print-color-adjust: exact;
      print-color-adjust: exact;
    }
  }
</style>`;

function relToAbs(href: string): string {
  const link = document.createElement('a');
  link.href = href;

  let linkHost = link.host;
  if (linkHost.indexOf('/') === -1 && link.pathname.indexOf('/') !== 0) {
    linkHost += '/';
  }

  return link.protocol + '//' + linkHost + link.pathname + link.search;
}

function styleToAbs(el: Element): string {
  const clone = el.cloneNode(true) as HTMLElement;

  if (clone.nodeName.toLowerCase() === 'link') {
    (clone as HTMLLinkElement).href = relToAbs((clone as HTMLLinkElement).href);
  }

  return clone.outerHTML;
}

export function applyDataTablesPrintFix(): void {
  if (typeof $ === 'undefined' || !$.fn || !$.fn.dataTable || !$.fn.dataTable.ext) return;

  const printButton = $.fn.dataTable.ext.buttons && $.fn.dataTable.ext.buttons.print;
  if (!printButton || printButton[patchFlag]) return;

  const originalAction = printButton.action;

  printButton.action = function (e: any, dt: any, button: any, config: any) {
    if (config && config.autoPrint === false && originalAction) {
      return originalAction.call(this, e, dt, button, config);
    }

    const exportOptions = $.extend({ decodeEntities: false }, config.exportOptions);
    const data = dt.buttons.exportData(exportOptions);
    const exportInfo = dt.buttons.exportInfo(config);
    const columnClasses = dt
      .columns(config.exportOptions.columns)
      .flatten()
      .map(function (idx: any) {
        return dt.settings()[0].aoColumns[dt.column(idx).index()].sClass;
      })
      .toArray();

    const addRow = function (rowData: any[], tag: string) {
      let row = '<tr>';

      for (let i = 0; i < rowData.length; i++) {
        const dataOut = rowData[i] === null || rowData[i] === undefined ? '' : rowData[i];
        const classAttr = columnClasses[i] ? 'class="' + columnClasses[i] + '"' : '';

        row += '<' + tag + ' ' + classAttr + '>' + dataOut + '</' + tag + '>';
      }

      return row + '</tr>';
    };

    let html = '<table class="' + dt.table().node().className + '">';

    if (config.header) {
      html += '<thead>' + addRow(data.header, 'th') + '</thead>';
    }

    html += '<tbody>';
    for (let i = 0; i < data.body.length; i++) {
      html += addRow(data.body[i], 'td');
    }
    html += '</tbody>';

    if (config.footer && data.footer) {
      html += '<tfoot>' + addRow(data.footer, 'th') + '</tfoot>';
    }
    html += '</table>';

    const iframe = document.createElement('iframe');
    iframe.style.position = 'fixed';
    iframe.style.right = '0';
    iframe.style.bottom = '0';
    iframe.style.width = '0';
    iframe.style.height = '0';
    iframe.style.border = '0';
    iframe.style.visibility = 'hidden';
    document.body.appendChild(iframe);

    const printWindow = iframe.contentWindow;
    const printDocument = iframe.contentDocument || (printWindow && printWindow.document);

    if (!printWindow || !printDocument) {
      document.body.removeChild(iframe);
      dt.buttons.info(
        dt.i18n('buttons.printErrorTitle', 'Unable to open print view'),
        dt.i18n('buttons.printErrorMsg', 'Please try again.'),
        5000
      );
      return;
    }

    let head = '<title></title>';
    $('style, link').each(function () {
      head += styleToAbs(this);
    });
    head += printPageStyle;

    printDocument.open();
    printDocument.write('<!doctype html><html><head>' + head + '</head><body></body></html>');
    printDocument.close();

    printDocument.body.innerHTML =
      '<h1>' + exportInfo.title + '</h1>' +
      '<div>' + (exportInfo.messageTop || '') + '</div>' +
      html +
      '<div>' + (exportInfo.messageBottom || '') + '</div>';

    $(printDocument.body).addClass('dt-print-view');

    $('img', printDocument.body).each(function (_i: number, img: HTMLImageElement) {
      img.setAttribute('src', relToAbs(img.getAttribute('src') || ''));
    });

    if (config.customize) {
      config.customize(printWindow, config, dt);
    }

    const cleanup = function () {
      if (iframe.parentNode) {
        iframe.parentNode.removeChild(iframe);
      }
    };

    printWindow.onafterprint = cleanup;
    printWindow.setTimeout(function () {
      printWindow.focus();
      printWindow.print();
      window.setTimeout(cleanup, 60000);
    }, 1000);
  };

  printButton[patchFlag] = true;
}
